import "./SelectionList.css";
import { useMemo, useState } from "react";

export default function SelectionList(props) {
  const {
    items,
    getId,
    matches,
    renderRow,
    renderActions,
    searchPlaceholder,
    filters,
    filterOf,
    emptyLabel,
    label,
  } = props;

  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState(filters ? filters[0].value : null);
  const [selected, setSelected] = useState([]);

  const visible = useMemo(() => {
    const trimmed = query.trim().toLowerCase();
    return items.filter((item) => {
      if (filters && filter !== filters[0].value && filterOf(item) !== filter) {
        return false;
      }
      return !trimmed || matches(item, trimmed);
    });
  }, [items, query, filter, filters, filterOf, matches]);

  const visibleIds = visible.map(getId);
  const allVisibleHeld =
    visibleIds.length > 0 && visibleIds.every((id) => selected.includes(id));

  function toggle(id) {
    setSelected((held) =>
      held.includes(id) ? held.filter((one) => one !== id) : held.concat(id)
    );
  }

  function toggleVisible() {
    setSelected((held) =>
      allVisibleHeld
        ? held.filter((id) => !visibleIds.includes(id))
        : held.concat(visibleIds.filter((id) => !held.includes(id)))
    );
  }

  const clear = () => setSelected([]);

  return (
    <div className="sel col">
      <div className="sel-controls row">
        <input
          className="sel-search"
          type="search"
          value={query}
          placeholder={searchPlaceholder}
          onChange={(e) => setQuery(e.target.value)}
          aria-label={searchPlaceholder}
        />
        {filters ? (
          <div className="sel-filters row" role="group" aria-label="Filter">
            {filters.map((option) => (
              <button
                key={option.value}
                type="button"
                className={`sel-filter${filter === option.value ? " sel-filter-on" : ""}`}
                aria-pressed={filter === option.value}
                onClick={() => setFilter(option.value)}
              >
                {option.label}
              </button>
            ))}
          </div>
        ) : null}
      </div>

      <div className="sel-head row">
        <label className="sel-check-label row">
          <input
            type="checkbox"
            checked={allVisibleHeld}
            disabled={!visibleIds.length}
            onChange={toggleVisible}
          />
          <span className="t-body-sm t-dimmer">
            {allVisibleHeld ? "Clear these" : "Select these"}
          </span>
        </label>
        <span className="t-body-sm t-dimmer">
          {visible.length} of {items.length} shown
          {selected.length ? ` · ${selected.length} selected` : ""}
        </span>
      </div>

      {selected.length ? (
        <div className="sel-actions row">
          <span className="t-body-sm sel-actions-count">
            {selected.length} selected
          </span>
          <div className="sel-actions-buttons row">
            {renderActions(selected, clear)}
            <button type="button" className="sel-clear t-body-sm" onClick={clear}>
              Clear selection
            </button>
          </div>
        </div>
      ) : null}

      {visible.length ? (
        <ul className="sel-list col" aria-label={label}>
          {visible.map((item) => {
            const id = getId(item);
            const held = selected.includes(id);
            return (
              <li key={id} className={`sel-row row${held ? " sel-row-on" : ""}`}>
                <input
                  className="sel-row-check"
                  type="checkbox"
                  checked={held}
                  onChange={() => toggle(id)}
                  aria-label={`Select ${props.labelOf ? props.labelOf(item) : id}`}
                />
                <div className="sel-row-body">{renderRow(item, held)}</div>
              </li>
            );
          })}
        </ul>
      ) : (
        <p className="t-body-sm t-dimmer">{emptyLabel}</p>
      )}
    </div>
  );
}
